import { Component, OnInit, OnDestroy, ViewChild, Input, AfterViewInit, forwardRef, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MyApp } from 'src/app/api/helper/app';
import { AlertController, IonInput, IonPopover } from '@ionic/angular';
import { Utils } from 'src/app/api/helper/utils';

import moment from 'moment';
import { ValidationHelper } from 'src/app/api/helper/validation-helper';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { BarcodeAuthGuard } from '../../barcode.guard';

const log = new Logger('InputDatum');

@Component({
    selector: 'app-input-datum',
    templateUrl: './input-datum.component.html',
    styleUrls: ['./input-datum.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => InputDatum),
        multi: true
    }],
    standalone: false
})
export class InputDatum implements ControlValueAccessor, OnInit, OnDestroy, AfterViewInit, OnChanges {

    @ViewChild('input', { read: IonInput, static: true }) input: IonInput;
    @ViewChild('popover', { read: IonPopover }) popover: IonPopover;

    @Input() titel: string;
    @Input() lines = 'none';

    @Input() disabled = false;
    @Input() readOnly = false;
    @Input() enterkeyhint = 'done';
    @Input() required = false;
    @Input() clearInput = false;
    @Input() isInvalid = false;
    @Input() paddingStart = undefined;
    @Input() labelPosition: 'stacked' = undefined;
    @Input() scanBarcodeButton = false;

    /**
     * Ein Validierungsstring. Wird z.B. aus den Positions-Eigenschaften gefüllt.
     * Das Format ist z.B. min_alter:6:monate|max_alter:4:jahre
     */
    @Input() validation: string = null;

    @Output() valueChanged = new EventEmitter<any>();
    @Output() lostFocus = new EventEmitter<any>();

    subscriptions: Subscription[] = [];

    isVisible = false;

    inputSlot: any = 'end';

    isClearButtonVisible = false;
    isEmptySpaceVisible = false;

    pattern = '^\\d{1,2}\\.\\d{1,2}\\.\\d{4}$';

    style = '';

    dateTimeValue = '';

    app = MyApp.current;

    private _value: string;

    nfcAlert: any;

    fehlermeldung = '';

    /** 
     * Datum wann das Popover geöffnet wurde zur Datumsauswahl
     */
    selectDatumDate = 0;

    // Whatever name for this (myValue) you choose here, use it in the .html file.
    public get myValue(): string { return this._value }

    public set myValue(v: string) {
        if (v !== this._value) {
            this._value = v;
            this.onChange(v);

            if (this.isVisible) {
                this.validate();
            }
        }
    }

    constructor(
        private alertController: AlertController,
        private cdr: ChangeDetectorRef,
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        // log?.debug('changed ' + this.titel, changes);

        this.updateType();

        if (changes?.pattern || changes?.validation) {
            if (this.isVisible) {
                // Der Regex wurde aktualisiert. Die Validierung muss erneut angestoßen werden
                this.validate();
            }
        }
    }

    onChange = (_) => {
        if (this.isVisible) {
            this.validate();
        }
    };

    onTouched = () => { };

    writeValue(value: any): void {
        this.myValue = value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
    }

    ngOnInit() {
        this.isVisible = true;
        this.updateType();
        this.validate();
    }

    async ngAfterViewInit() {
        setTimeout(() => {
            this.validate();

            this.cdr.detectChanges();
        });
    }

    ngOnDestroy() {
    }

    async ionViewWillEnter() {
    }

    ionViewDidEnter() {
    }

    ionViewWillLeave() {
    }

    onClearValue() {
        this.myValue = null;
        this.valueChanged.next(this._value);

        this.input.setFocus();
    }

    updateType() {
        this.isClearButtonVisible = false;


        // if (this.plusMinusButtons && !this.disabled && !this.readOnly) {
        //     this.isPlusButtonVisible = true;
        //     this.isMinusButtonVisible = true;
        // }

        if (this.clearInput) {
            this.isClearButtonVisible = true;
        }

        if (!this.isClearButtonVisible) {
            this.isEmptySpaceVisible = true;
        }

        this.style = '';

        if (this.paddingStart != null) {
            this.style += '--padding-start: ' + this.paddingStart;
        }

        if (this.labelPosition === 'stacked') {
            this.inputSlot = ''; // undefined;
        } else {
            this.inputSlot = 'end';
        }
    }

    onBlur(e: any) {
        this.korrigiereEingabe();

        this.lostFocus.next(e);
        this.valueChanged.next(this._value);

        // Beim Verlassen des Feldes soll eine eventuelle Fehlermeldung angezeigt werden
        this.validate(true);
    }

    onValueChange(e: any) {
        this.korrigiereEingabe();

        this.valueChanged.next(this._value);
        this.validate();
    }

    async selectDatum(e: any) {
        log?.debug('selectDatum: ' + this.titel);

        if (this.readOnly) {
            return;
        }

        try {
            let m: moment.Moment = null;

            if (this._value && this._value.length >= 8 && this._value.length <= 10) {
                m = Utils.parseDatum(this._value)?.local();
            }

            if (!m) {
                m = moment();
            }

            this.selectDatumDate = Date.now();

            this.dateTimeValue = m.toISOString(true);

            this.cdr.detectChanges();

            await Utils.delay(1);

            await this.popover.present(e);

            // await this.popover.onDidDismiss();

            // alert('ok');

            // this.myValue = m.format('DD.MM.YYYY');
            // this.valueChanged.next(this._value);
            // this.validate();

            setTimeout(() => {
                MyApp.closeAnyKayboard();
            }, 100);
        } catch (err) {
            // UiHelper.showError(err);
        }
    }

    async onDateSelected(e: any) {
        log?.debug('onDateSelected: ' + this.titel, e);

        if (this.selectDatumDate > Date.now() - 200) {
            // ignore
            return;
        }

        if (this.popover) {
            this.popover.dismiss();
        }

        const value = e.detail?.value;

        if (value) {
            const m = Utils.parseDatum(value);

            if (m) {
                this.myValue = m.format('DD.MM.YYYY');
                this.valueChanged.next(this._value);

                // Wenn der Benutzer ein ungültigs Datum ausgewählt hat, dann soll auch direkt eine Fehlermeldung angezeigt werden
                this.validate(true);
            }
        }
    }

    /**
     * Korrigiert falsche Eingaben im Form z.B.: 1.3.23
     */
    korrigiereEingabe() {
        log?.debug('korrigiereEingabe');

        if (this._value && typeof (this._value) === 'string') {
            const str = this._value;
            const parts = str.split(/[\.,\/]/);

            let tag = -1;
            let monat = -1;
            let jahr = -1;
            let aktuellesJahr = new Date().getFullYear();

            if (parts.length == 2) {
                tag = Utils.parseInt(parts[0]);
                monat = Utils.parseInt(parts[1]);
                jahr = aktuellesJahr;
            } else if (parts.length == 3) {
                tag = Utils.parseInt(parts[0]);
                monat = Utils.parseInt(parts[1]);
                jahr = Utils.parseInt(parts[2]);

                if (jahr > 1 && jahr < 100) {
                    // Jahr wurde zweistellig eingegebn
                    jahr = 2000 + jahr;
                }
            }

            if (tag >= 1 && tag <= 31) {
                if (monat >= 1 && monat <= 12) {
                    if (jahr >= 2000 && jahr <= 2999) {
                        const z = n => ('0' + n).slice(-2);
                        const zz = n => ('000' + n).slice(-4);

                        let neuerWert = `${z(tag)}.${z(monat)}.${zz(jahr)}`;

                        if (neuerWert != str) {
                            log?.info(`Datum korrigiert. Alt=${str}, Neu=${neuerWert}`);
                            this.myValue = neuerWert;
                        }
                    }
                }
            }
        }
    }

    validate(fehlermeldungAnzeigen = false): boolean {
        this.isInvalid = false;
        this.fehlermeldung = '';

        if (this.pattern && this.pattern != '.*' && this._value) {
            this.isInvalid = false;

            try {
                const wert = Utils.trimToEmpty(this._value);

                if (!wert.match(this.pattern)) {
                    this.isInvalid = true;
                }

            } catch (err) {
                log.warn('Fehler in Regex ' + this.pattern + ': ' + Utils.getErrorMessage(err));
            }
        }

        if (this.required && !this._value) {
            this.isInvalid = true;
        }

        if (!this.isInvalid && this.validation) {
            let validation = ValidationHelper.validateDatum(this._value, this.validation);

            if (!validation.isValid) {
                this.isInvalid = true;
                this.fehlermeldung = validation.message;
            }
        }

        if (this.fehlermeldung && fehlermeldungAnzeigen) {
            UiHelper.showAlert(this.fehlermeldung, this.titel);
        }

        return !this.isInvalid;
    }

    async scanBarcode() {
        log?.debug('scanEigenschaftBarcode: ' + this.titel);

        BarcodeAuthGuard.barcodeScanAktiv = true;

        try {
            let barcodeData = await MyApp.scanBarcode();

            log?.debug(`scanEigenschaftBarcode ${this.titel}: ${barcodeData?.text}`);

            if (barcodeData?.text) {
                // Es kann nur Datum gescannt werden
                let text = barcodeData.text as string;

                // Wenn Geburtsdatum gescannt wird, muss es immer in dem Format kommen
                if (!/^\d{10}$/.test(text)) {
                    throw new Error('Ungültiges Format. Erwartet: TTMMYYYYxx');
                }

                const tag = text.substring(0, 2);
                const monat = text.substring(2, 4);
                const jahr = text.substring(4, 8);

                // return `${tag}.${monat}.${jahr}`;

                this.myValue = `${tag}.${monat}.${jahr}`;
            }
        } catch (err) {
            UiHelper.showErrorLight(err);
        }

        setTimeout(() => BarcodeAuthGuard.barcodeScanAktiv = false, 500);
    }
}
